<template>
  <div class="components">
    <!-- 轮播图区域 -->
    <image-carousel :images="images" />

    <!-- 标题区域 -->
    <div class="section-header">
      <h3 class="main-title">聚势汇能，盈创未来</h3>
      <p class="sub-title">闪耀星启</p>
    </div>

    <!-- 6张图片展示区域 -->
    <div class="card-grid-container">
      <div
          v-for="(item, index) in featureCards"
          :key="index"
          class="feature-card"
          :style="{ maxWidth: cardMaxWidth }"
      >
        <!-- 图片包裹层：完全按原图撑开，无固定高，无底色 -->
        <div class="card-img-wrapper">
          <img :src="item.img" :alt="'图片' + (index + 1)" class="card-img">
        </div>
        <div class="card-info">
          <p class="card-desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>

    <el-backtop :right="24" :bottom="56"></el-backtop>
  </div>
</template>

<script>
import ImageCarousel from './ImageCarousel.vue'

export default {
  name: 'HelloWorld',
  components: {
    ImageCarousel
  },
  data() {
    return {
      // ----------------【调节卡片/图片大小】----------------
      // 修改这个值（如 '500px'、'650px'、'100%'），即可调节图片大小！
      // 宽度变大，图片高度就会完全按原图比例自动变高，绝对不会变形或裁切
      cardMaxWidth: '600px',
      // ----------------------------------------------------

      images: [
        { url: require('../assets/img/gun1.png'), alt: '图片1' },
        { url: require('../assets/img/gun2.png'), alt: '图片2' },
        { url: require('../assets/img/gun3.png'), alt: '图片3' },
      ],
      featureCards: [
        { img: require('../assets/img/aaa.jpg'), desc: '2025年4月参加技术经理人培训院院长致辞。' },
        { img: require('../assets/img/bbb.jpg'), desc: '2025年5月技术经理人培训线下路演活动，向专家展示我们的产品。' },
        { img: require('../assets/img/fff.jpg'), desc: '课题组结题大会' },
        { img: require('../assets/img/eee.jpg'), desc: '孤独症日图画长卷' },
        { img: require('../assets/img/ertongyiyuan.jpg'), desc: '儿童医院合作备案展示' },
        { img: require('../assets/img/jingdong.jpg'), desc: '京东合作协议查看' }

      ]
    }
  },
}
</script>

<style scoped>
.components {
  width: 100%;
  overflow-x: hidden;
  padding-bottom: 80px;
  box-sizing: border-box;
}

/* 轮播图的样式在 ImageCarousel.vue 里（两页共用） */

/* 标题区域 */
.section-header {
  text-align: center;
  margin: 50px 20px 40px 20px;
}

.main-title {
  font-size: clamp(2rem, 3.5vw, 3.2rem);
  font-weight: 800;
  color: #1f2937;
  margin: 0 0 12px 0;
}

.sub-title {
  font-size: clamp(1rem, 1.5vw, 1.2rem);
  color: #6b7280;
  margin: 0;
}

/* 6张图片网格布局：增加行间距，卡片居中 */
.card-grid-container {
  width: 90%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 60px 40px; /* 上下行间距 60px，左右列间距 40px */
  justify-items: center; /* 确保卡片在网格内居中 */
  align-items: start;
}

.feature-card {
  width: 100%; /* 继承 grid 的宽度，最高不超过 cardMaxWidth */
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #eef0f2;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.12);
}

/* 图片容器：不做任何高度限制，不设背景背景色 */
.card-img-wrapper {
  width: 100%;
  height: auto;
  overflow: hidden;
}

/* 纯原图比例渲染：宽度填满卡片，高度完全自动计算，绝无贴边白块 */
.card-img {
  width: 100%;
  height: auto;
  display: block;
}

.card-info {
  padding: 20px 24px;
  background-color: #ffffff;
  border-top: 1px solid #f0f2f5;
}

.card-desc {
  margin: 0;
  font-size: clamp(14px, 1.1vw, 16px);
  color: #374151;
  line-height: 1.6;
  text-align: center;
}

@media (max-width: 768px) {
  .card-grid-container {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}

@media (max-width: 560px) {
  .components {
    padding-bottom: 56px;
  }

  .section-header {
    margin: 32px 14px 28px;
  }

  .main-title {
    font-size: clamp(1.7rem, 6.5vw, 2.2rem);
  }

  .card-grid-container {
    width: 92%;
    gap: 26px;
  }

  .card-info {
    padding: 14px 16px;
  }

  .card-desc {
    font-size: 14px;
  }
}
</style>